import React, { useEffect, useMemo, useState } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { StyledTable } from './styled';
import { getAMLSTMCommonCustomerLoanDetails } from '../../../redux/actions/tmCommon';
import {
  DEFAULT_PAGE_SIZE,
  DEFAULT_CURRENT_PAGE
} from '../../constants/commonConstants';
import { genarateTableConfigs } from '../utils';
import ComponentsMap from '../ComponentsMap';
import { LOAN_DETAILS_MAP_NAMESPACE } from './constants';

import { isEmpty, result } from '../../../util/lodashlike';
export const LoanDetails = ({
  dispatch,
  customerId,
  widgetConfig,
  isLoading,
  data
}) => {
  const [currentPage, setCurrentPage] = useState(DEFAULT_CURRENT_PAGE);

  const { payload, total: totalCount } = data;

  const getLoanDetails = ({ offset }) => {
    dispatch(
      getAMLSTMCommonCustomerLoanDetails({
        customerId,
        limit: DEFAULT_PAGE_SIZE,
        offset
      })
    );
  };

  useEffect(() => {
    if (!isEmpty(customerId)) {
      getLoanDetails({ offset: 0 });
    }
  }, [customerId]);

  const onPageChange = ({ current }) => {
    setCurrentPage(current);
    getLoanDetails({ offset: (current - 1) * DEFAULT_PAGE_SIZE });
  };

  const pagination = useMemo(
    () => ({
      total: totalCount,
      current: currentPage,
      pageSize: DEFAULT_PAGE_SIZE,
      showTotal: (total) => `${total} Records`,
      showSizeChanger: false
    }),
    [totalCount, currentPage]
  );

  const tableColumns = useMemo(
    () =>
      genarateTableConfigs({
        settings: widgetConfig,
        configs: result(ComponentsMap, LOAN_DETAILS_MAP_NAMESPACE) || {}
      }),
    [widgetConfig]
  );

  return (
    <StyledTable
      rowKey="loanKey"
      columns={tableColumns}
      dataSource={payload}
      loading={isLoading}
      onChange={onPageChange}
      pagination={pagination}
      scroll={{ x: 240 }}
    />
  );
};

LoanDetails.propTypes = {
  dispatch: PropTypes.func.isRequired,
  customerId: PropTypes.string,
  isLoading: PropTypes.bool.isRequired,
  widgetConfig: PropTypes.array.isRequired,
  data: PropTypes.object
};

const mapStateToProps = ({ amlsTMCommon }) => {
  const { data, isLoading } = amlsTMCommon.customerLoanDetails;

  return {
    isLoading,
    data
  };
};

export default connect(mapStateToProps)(LoanDetails);
